// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-loader__loader{display:flex;align-items:center;justify-content:center}.page-loader--loading,.page-loader__loader{position:absolute;top:0;left:0;right:0;bottom:0}", ""]);
// Exports
module.exports = exports;
